import { del, get, patch, post } from '@/services/awsAmplify'
import { getMentionsFromMarkdown } from '@/utils/getMentionsFromMarkdown'
import { replaceMentionsWithUsernames } from '@/utils/replaceMentionsWithUsernames'

import { IMention, IReply } from '@/interfaces'

import { MediaType } from '@/plugins/ugc-composer'

type CreateConversationResponseType = {
  id: UUID
  userID: UUID
  createdAt: string
  updatedAt: string
  mediaType: MediaType
  title: string
  caption: string
  username: string
  mentions: IMention[]
  replies: IReply[]
  tags: string
  isDiscoverable: boolean
  blockedByRecognitionService: boolean
}

export const createConversation = async (body: {
  title: string
  caption: string
  mediaType: MediaType
}) => {
  const strippedCaption = replaceMentionsWithUsernames(body.caption)
  const mentions = getMentionsFromMarkdown(body.caption)

  return (await post({
    path: '/conversations',
    params: {
      title: body.title,
      caption: strippedCaption,
      mentions,
      mediaType: body.mediaType,
    },
  })) as unknown as CreateConversationResponseType
}

export const getConversation = async (id: UUID) => {
  return get({
    path: `/conversations/${id}`,
  })
}

type CreateConversationReplyResponseType = {
  id: UUID
  userID: UUID
  createdAt: string
  updatedAt: string
  avatar: string
  username: string
  caption: string
  mentions: IMention[]
  isAmbassador: boolean
  isModerator: boolean
}

export const createConversationReply = async (payload: {
  id: UUID
  caption: string
  mediaType: MediaType
}) => {
  const strippedCaption = replaceMentionsWithUsernames(payload.caption)
  const mentions = getMentionsFromMarkdown(payload.caption)

  return (await post({
    path: `/conversations/${payload.id}/replies`,
    params: {
      caption: strippedCaption,
      mentions: mentions,
      mediaType: payload.mediaType,
    },
  })) as unknown as CreateConversationReplyResponseType
}

export const deleteConversation = async (conversationId: UUID) => {
  return await del({
    path: `/conversations/${conversationId}`,
  })
}

export const deleteReplies = async (payload: {
  conversationId: UUID
  replyIds: UUID[]
}) => {
  //TODO: replace del with patch or put to support body params
  return await del({
    path: `/conversations/${payload.conversationId}/replies`,
    params: {
      replyIds: payload.replyIds,
    },
  })
}

export const deleteReply = async (payload: {
  conversationId: UUID
  replyId: UUID
}) => {
  return await del({
    path: `/conversations/${payload.conversationId}/replies/${payload.replyId}`,
  })
}

export const pinReplies = async (payload: {
  conversationId: UUID
  replyIds: UUID[]
}) => {
  return await patch({
    path: `/conversations/${payload.conversationId}/replies/pin`,
    params: {
      replyIds: payload.replyIds,
    },
  })
}
